// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { AcademicTerm, HomeRoom, HomeRoomSection, Room } from "../../../Utilities";
import { StudentHomeRoomSectionEnrollmentFormValues } from "../StudentHomeRoomSectionEnrollment";
import { TeacherHomeRoomSectionEnrollmentFormValues } from "../TeacherHomeRoomSectionEnrollment";

export type Base = {
	namePrefix: HomeRoomSection["namePrefix"];
	nameSuffix: HomeRoomSection["nameSuffix"];
	academicTermID: AcademicTerm["id"] | null;
	homeRoomID: HomeRoom["id"] | null;
	roomID: Room["id"] | null;
};

export type Create = Base & {
	studentHomeRoomSectionEnrollments: StudentHomeRoomSectionEnrollmentFormValues.CreateInHomeRoomSection[];
	teacherHomeRoomSectionEnrollments: TeacherHomeRoomSectionEnrollmentFormValues.CreateInHomeRoomSection[];
};

export type CreateRequiredKey = Extract<keyof Create, "academicTermID" | "homeRoomID">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	namePrefix: "",
	nameSuffix: "",
	academicTermID: null,
	homeRoomID: null,
	roomID: null,
	studentHomeRoomSectionEnrollments: [],
	teacherHomeRoomSectionEnrollments: [],
};

export type Detail = Base;

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;
